module.exports = __webpack_public_path__ + "static/media/27OCHA13.37b9ee05.jpg";